// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__63RHM","redColor":"style_redColor__SP0aJ","greenColor":"style_greenColor__kxedl","summaryCell":"style_summaryCell__cpSgp","content":"style_content__JnmzW"};